import React, { useContext, useEffect } from "react";
import { useFormik } from "formik";
import * as yup from "yup";

import LeftSidePopupLayout from "../../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../../component/icons/x-close";
import Style from "./style.module.css";

import { GlobalContext } from "../../../../../context/Context";
import { useApiCall } from "../../../../../component/custom-hooks/api-call";

import {
    FeildError,
    FeildWraper,
    FormArea,
    FormLabel,
    SelectSearch,
} from "../../../../../component/form/form-layout";

const LeadStatusUpdate = ({
    leadData,
    status,
    statusCode,
    statusList = [],
    onSubmit = () => { },
    onClose = () => { },
    onError = () => { },
}) => {
    const { state } = useContext(GlobalContext);
    const apiCall = useApiCall();


    const statusOptions = statusList?.map((s) => ({
        value: s.id,
        label: s.value,
    }));


    const selectedStatusOption = statusOptions?.find(
        (opt) => opt.value === leadData?.status_code
    );

    const validationSchema = yup.object({
        status: yup.object().required("Status is required"),
        comment: yup.string().required("Comment is required"),
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            status: statusCode || "",
            comment: "",
        },
        validationSchema: yup.object({
            status: yup.string().required("Status is required"),
            comment: yup.string().required("Comment is required"),
        }),
        onSubmit: async (values) => {
            try {
                // 1️⃣ Append the status change line only on submit
                const userName = state?.user?.name;
                const previousStatus = leadData?.LeadStatus;
                const newStatusLabel = statusOptions.find(s => s.value === values.status)?.label;
                let updatedComment = values.comment || "";

                if (previousStatus && newStatusLabel && userName) {
                    const statusLine = `Changed status from <b>${previousStatus}</b> to <b>${newStatusLabel}</b>`;
                    updatedComment = updatedComment ? `${statusLine}\n\n${updatedComment}` : statusLine;
                }

                // 2️⃣ Call API with updated comment
                await apiCall({
                    method: "post",
                    url: `leads/update-lead-status/${leadData?.id}`,
                    data: { leadstatus: values.status },
                });

                await apiCall({
                    method: "post",
                    url: `lead/add-lead-comment`,
                    data: { lead_id: leadData?.id, comment: updatedComment },
                });

                formik.resetForm();

                onSubmit(
                    "Status updated successfully",
                    statusOptions.find((s) => s.value === values.status)?.label,
                    values.status
                );

                onClose();
            } catch (error) {
                onError(
                    error?.response?.data?.respMsg ||
                    error?.response?.data?.message ||
                    "Something went wrong"
                );
            }
        }
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <LeftSidePopupLayout
                popupStatus={true}
                className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}
            >
                {/* Header */}
                <div
                    className={`${Style.modal_header} ${Style.addMeModal_head} flex justify-between items-center`}
                >
                    <h4>Update Status</h4>
                    <div onClick={onClose} className={`${Style.close_btn} cursor-pointer`}>
                        <XCloseIcon />
                    </div>
                </div>

                {/* Body */}
                <div className={Style.addMeModal_body}>
                    <div className={Style.dcmb__card}>
                        <div className={Style.dcmb__cardBody}>
                            <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
                                <FormArea>
                                    {/* Status */}
                                    <FeildWraper width="100%">
                                        <FormLabel required>Status</FormLabel>
                                        <SelectSearch
                                            name="status"
                                            placeholder="- Select Status -"
                                            options={statusOptions}
                                            value={formik.values.status}  // id
                                            onChange={(val) => formik.setFieldValue("status", val)} // id
                                            onBlur={() => formik.setFieldTouched("status", true, true)}
                                            menuPosition="fixed"
                                        />
                                        {formik.touched.status && formik.errors.status && (
                                            <FeildError>{formik.errors.status}</FeildError>
                                        )}
                                    </FeildWraper>

                                    {/* Comment */}
                                    <FeildWraper width="100%">
                                        <FormLabel required>Comment</FormLabel>
                                        <textarea
                                            name="comment"
                                            rows={4}
                                            placeholder="Write comment..."
                                            value={formik.values.comment}
                                            onChange={formik.handleChange}
                                        />
                                        {formik.touched.comment && formik.errors.comment && (
                                            <FeildError>{formik.errors.comment}</FeildError>
                                        )}
                                    </FeildWraper>
                                </FormArea>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className={Style.dcmb__cardFoot}>
                    <button
                        type="button"
                        className={Style.dcmb__cancel}
                        onClick={onClose}
                    >
                        Discard
                    </button>
                    <button type="submit" className={Style.dcmb__submit}>
                        Apply
                    </button>
                </div>
            </LeftSidePopupLayout>
        </form>
    );
};

export default LeadStatusUpdate;